import { useSeo } from "@/lib/useSeo";
import { useApi } from "@/lib/api";
import { Reveal, Spinner } from "@/components/site/kit";
import { DeletionForm, GrievanceForm } from "@/components/site/RequestForms";
import NotFound from "@/pages/NotFound";

const FORMS = {
  "data-deletion": { title: "Submit a data deletion request", Form: DeletionForm },
  grievance: { title: "File a complaint", Form: GrievanceForm },
};

export default function LegalPage({ slug }) {
  const { data: p, isLoading, isError } = useApi(`/legal/${slug}`);
  useSeo({ title: p?.seo_title || p?.title, description: p?.seo_description });
  if (isLoading) return <Spinner className="min-h-[60vh]" />;
  if (isError || !p) return <NotFound />;
  const extra = FORMS[slug];
  const updated = p.last_updated ? new Date(p.last_updated).toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" }) : "";

  return (
    <>
      <section className="border-b border-line bg-white">
        <div className="container-x py-14 sm:py-16">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-sky">Legal</p>
          <h1 className="mt-3 text-4xl font-extrabold tracking-tight sm:text-5xl" data-testid="legal-title">{p.title}</h1>
          {updated && <p className="mt-3 text-sm text-muted2" data-testid="legal-last-updated">Last updated: {updated}</p>}
        </div>
      </section>
      <section className="bg-page py-14 sm:py-16">
        <div className="container-x grid gap-10 lg:grid-cols-[1fr_380px]">
          <article className="card-base legal-content p-6 sm:p-10" data-testid="legal-content" dangerouslySetInnerHTML={{ __html: p.content }} />
          {extra && (
            <aside className="lg:sticky lg:top-24 lg:self-start">
              <Reveal>
                <div className="card-base p-6 sm:p-7">
                  <h2 className="mb-5 text-xl font-bold">{extra.title}</h2>
                  <extra.Form />
                </div>
              </Reveal>
            </aside>
          )}
        </div>
      </section>
    </>
  );
}
